// Generador de ids únicos para entidades creadas en el cliente (p.ej. partidas
// del presupuesto). NO usar crypto.randomUUID() a pelo: solo existe en contextos
// seguros (HTTPS o localhost) y la app del VPS se sirve por HTTP contra la IP —
// ahí crypto.randomUUID es undefined y la llamada revienta el render (pantalla
// en blanco, bug 2026-08-21). Este helper cae a un UUID v4 hecho con
// getRandomValues (disponible también en HTTP) y, como última red, Math.random.
export function uid() {
  const c = typeof globalThis !== "undefined" ? globalThis.crypto : undefined;
  if (c?.randomUUID) return c.randomUUID();

  const bytes = new Uint8Array(16);
  if (c?.getRandomValues) {
    c.getRandomValues(bytes);
  } else {
    for (let i = 0; i < 16; i++) bytes[i] = Math.floor(Math.random() * 256);
  }
  // Marcar versión (4) y variante (10xx) según RFC 4122.
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
